import { render } from "./SidebarItem.vue?vue&type=template&id=d0ea0af2&scoped=true"
import script from "./SidebarItem.vue?vue&type=script&lang=js"
export * from "./SidebarItem.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-d0ea0af2"

export default script